/**
 * 俯視嘅一張夜晚持牌行人路枱：圓枱、兩張凳、一枝點著嘅雪茄、杯、地面格紋，
 * 左右用深綠虛線標示「露天位｜行人路」。呢個係首頁嘅主視覺 —— 產品嘅核心物件
 * 就係「一塊有面積、有時間窗嘅行人路」，唔係一個抽象 icon。
 */
export default function Illustration() {
  return (
    <svg className="art" viewBox="0 0 294 92" role="img"
      aria-label="露天座位示意圖：行人路上的圓枱、兩張凳同一枝雪茄">
      <defs>
        <pattern id="pav" width="8" height="8" patternUnits="userSpaceOnUse">
          <path d="M0 8 L8 0" stroke="#C9BBA0" strokeWidth="1.1" />
        </pattern>
      </defs>
      <rect x="0" y="0" width="294" height="92" fill="url(#pav)" opacity=".8" />
      <rect x="0.5" y="0.5" width="293" height="91" fill="none" stroke="#B9AB90" />

      {/* 凳（上）椅背 + 座 */}
      <rect x="128" y="6" width="38" height="9" rx="3" fill="#FBF6EA" stroke="#7A4E32" strokeWidth="1.8" />
      <rect x="132" y="15" width="30" height="13" rx="3" fill="#FBF6EA" stroke="#7A4E32" strokeWidth="1.8" />
      {/* 凳（下） */}
      <rect x="132" y="71" width="30" height="13" rx="3" fill="#FBF6EA" stroke="#7A4E32" strokeWidth="1.8" />
      <rect x="128" y="84" width="38" height="9" rx="3" fill="#FBF6EA" stroke="#7A4E32" strokeWidth="1.8" />

      {/* 枱 */}
      <circle cx="147" cy="46" r="24" fill="#FBF6EA" stroke="#7A4E32" strokeWidth="2.2" />
      <circle cx="147" cy="46" r="19" fill="none" stroke="#D9C9A9" strokeWidth="1" />

      {/* 雪茄：茄衣 + 雪茄標 + 火 + 煙 */}
      <rect x="128" y="41" width="34" height="7" rx="3.5" fill="#8A5A3B" />
      <rect x="150" y="41" width="8" height="7" fill="#A8402A" />
      <rect x="130" y="42.5" width="14" height="4" rx="2" fill="#A87C55" />
      <circle cx="127" cy="44.5" r="2.4" fill="#B08A3E" />
      <path d="M124 42 c-4 -4 -1 -8 -5 -11" stroke="#9C9082" strokeWidth="1.2" fill="none" />
      <path d="M126 41 c-3 -5 1 -9 -3 -13" stroke="#B5AC9C" strokeWidth="1.1" fill="none" />

      {/* 杯 */}
      <circle cx="166" cy="54" r="6" fill="#fff" stroke="#7A4E32" strokeWidth="1.6" />
      <circle cx="166" cy="54" r="3" fill="#EADFC7" />

      {/* 露天位邊界 */}
      <path d="M40 46 h30" stroke="#37503F" strokeWidth="1.8" strokeDasharray="4 3" />
      <path d="M224 46 h30" stroke="#37503F" strokeWidth="1.8" strokeDasharray="4 3" />
      <text x="14" y="49.5" fontFamily="Noto Serif CJK TC" fontSize="10" fontWeight="700" fill="#37503F">露天位</text>
      <text x="256" y="49.5" fontFamily="Noto Serif CJK TC" fontSize="10" fontWeight="700" fill="#37503F">行人路</text>
    </svg>
  );
}
